module.exports = __webpack_public_path__ + "img/revoke.48ac4a3e.svg";